import { gql } from '@apollo/client'
import { ApolloQueryResult } from '@apollo/client/core'
import { ApiLoyaltySettings } from '@vend/types'

export type RetailerLoyaltySettings = Pick<
  ApiLoyaltySettings,
  'thresholdSettings'
>

export type GetRetailerLoyaltyThresholdResult = {
  loyaltySettings: RetailerLoyaltySettings
}
export type GetRetailerLoyaltyThresholdResponse = ApolloQueryResult<GetRetailerLoyaltyThresholdResult>

export const getRetailerLoyaltyThreshold = gql`
  query GetRetailerLoyaltyThreshold {
    loyaltySettings {
      thresholdSettings {
        enabled
        value
      }
    }
  }
`
